import React from 'react';
import GameScoreBoard from '../GameScoreBoard.js';

class ComingSoon extends GameScoreBoard {

	 constructor(props) {
				super(props);
				this.state = {
				}	
	 }

	 render () {

    return (
			<div className="row justify-content-center">
				<div className="col-12 p-5 text-center"><h2>{this.props.name} : coming soon</h2></div>
				<div className="col-12 p-5 text-center"><button onClick={() => this.props.setGameType("Dashboard")} className="btn btn-secondary">Dashboard</button></div>
			</div>);
    }

}
export default ComingSoon;
